const defaults = {
  resource: 'blob',
  operation: 'getMany',
  containerName: '',
  blobName: '',
  contentBase64: '',
  contentType: '',
  overwrite: true,
  destinationContainer: '',
  destinationBlobName: '',
  deleteSnapshots: true,
  prefix: '',
  returnAll: false,
  limit: 50,
  accessLevel: 'private',
  simplifyOutput: true,
};

export default defaults;
